import {
  RouteConfig
} from 'vue-router'
import Layout from '@/layout/index.vue'

const cardRouter: RouteConfig = {
  path: '/cards',
  component: Layout,
  redirect: '/cards/card_list',
  name: '会员卡管理',
  meta: {
    title: '会员卡管理'
  },
  children: [
    {
      path: 'userCardList',
      name: 'userCardList',
      component: () => import(/* webpackChunkName: "cards" */'@/views/cards/userCardList.vue'),
      meta: {
        title: '用户的会员卡'
      }
    },
    {
      path: 'userCards/:userId',
      name: 'userCardsOfUserId',
      component: () => import(/* webpackChunkName: "cards" */'@/views/cards/userCardList.vue'),
      meta: {
        title: '用户的会员卡'
      }
    },
    {
      path: 'card_list',
      name: 'card_list',
      component: () => import(/* webpackChunkName: "cards" */'@/views/cards/cardList.vue'),
      meta: {
        title: '会员卡管理'
      }
    },
    {
      path: 'baseCardList',
      name: 'baseCardList',
      component: () => import(/* webpackChunkName: "cards" */'@/views/cards/baseCardList.vue'),
      meta: {
        title: '总部会员卡管理'
      }
    },
    {
      path: 'diffCardSetting',
      name: 'diffCardSetting',
      component: () => import(/* webpackChunkName: "cards" */'@/views/cards/DiffCardSetting.vue'),
      meta: {
        title: '补差卡设置'
      }
    },
  ]
}

export default cardRouter
